import { render, staticRenderFns } from "./VideoSource.vue?vue&type=template&id=e3333d16&scoped=true"
import script from "./VideoSource.vue?vue&type=script&lang=ts"
export * from "./VideoSource.vue?vue&type=script&lang=ts"
import style0 from "./VideoSource.vue?vue&type=style&index=0&id=e3333d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3333d16",
  null
  
)

export default component.exports